import { Action, createReducer, on } from '@ngrx/store';
import * as AppContextActions from './appcontext.actions';
import {NavSections} from "../../NavSections";
import {Globals} from "../../Globals";


const initialState :Globals = { 
    email:"", 
    userType: NavSections.public,
    clientID:0,
    clientName: "",
    userID:"",
    userName: "",
    Auths:[]};

const AppContextReducer = createReducer(
    initialState,
    on(AppContextActions.loggedInUserInfo, (state, action) => 
    {return action.item}));

export function reducer(state: Globals, action: Action) {
    return AppContextReducer(state, action);
}